import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';
import { StatementStatusEnum } from '../../models/StatementStatusEnum';

export const FilesClarifyLinkComponent: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();

		return (
			<>
				{
					uiState.IsDisabled &&
					<div className="form-step-info">
						{uiState.StatementStatus !== StatementStatusEnum.Received &&
							<p className="mb-0">
								Документы оператора ЭДО направлены на рассмотрение в ФНС России.
								Для изменения направленных в ФНС России сведений об операторе ЭДО или приложенных документов необходимо дождаться регистрации Вашего обращения.
							</p>
						}
						{(uiState.StatementStatus === StatementStatusEnum.Received && dataState.Statement?.LinkClarify) &&
							<>
								<p className="mb-0">Документы оператора ЭДО направлены на рассмотрение в ФНС России.</p>
								<p className="mb-0">Скачать документы невозможно.</p>
								<p className="mb-0">Для изменения направленных в ФНС России сведений об операторе ЭДО или приложенных документов перейдите по <a href={dataState.Statement.LinkClarify} className="link" target="_blank" rel="noopener noreferrer nofollow">ссылке</a>.</p>
							</>
						}
					</div>
				}
			</>
		);
	}
)
